import { render } from "./welHome.vue?vue&type=template&id=9ecbf95a&scoped=true"
import script from "./welHome.vue?vue&type=script&lang=js"
export * from "./welHome.vue?vue&type=script&lang=js"

import "./welHome.vue?vue&type=style&index=0&id=9ecbf95a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ecbf95a"]])

export default __exports__